import { gray } from '../../../../components/Color';
import FlexGrid, { FlexGridColumn } from '../../../../components/FlexGrid';
import { MovingGradient } from '../../../../components/MovingGradient';
import Typography from '../../../../components/Typography';
import { codes } from '../../../../data/translations';
import { useTranslationAPI } from '../../../translations';

export const ListLoadingSortByTooltipButton = () => {
	const { translate } = useTranslationAPI();

	return (
		<FlexGrid center>
			<FlexGridColumn>
				<Typography color={gray[6]}>{translate(codes.common.sortBy)}:</Typography>
				&nbsp;
			</FlexGridColumn>
			<FlexGridColumn>
				<Typography color={gray[8]}>
					<MovingGradient
						height='17px'
						width='92px'
					/>
				</Typography>
			</FlexGridColumn>
		</FlexGrid>
	);
};
